const IMAGE_TYPE_REGEX = /image\//g;

export const getImageTypeFromFile = (file: any): string | null => {
  if (!file || !file.type) return null;

  return file.type.replace(IMAGE_TYPE_REGEX, '');
};
